import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { TreoAnimations } from 'tsui/@treo';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { AccountService } from 'app/core';
import { User, UserAssociation, Invitation } from 'app/core/models/user.types';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'add-team',
  templateUrl: './add-team.component.html',
  styleUrls: ['./add-team.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddTeamComponent implements OnInit {
  private role: string = 'admin';
  private extra: any = {};
  public addTeamForm: UntypedFormGroup;
  public isLoading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<AddTeamComponent>,
    private readonly accountService: AccountService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly snackBar: MatSnackBar,
  ) {}

  public get isSaveBtnDisabled(): boolean {
    return this.isLoading || this.addTeamForm.pristine || this.addTeamForm.invalid;
  }

  ngOnInit(): void {
    this.buildForm();

    if (this.data?.role) {
      this.role = this.data.role;
    }
    if (this.data?.extra) {
      this.extra = this.data.extra;
    }
  }

  private buildForm(): void {
    this.addTeamForm = this.formBuilder.group({
      name: ['', [Validators.required]],
    });
  }

  public saveAndClose(): void {
    this.addTeamForm.disable();

    let team = this.addTeamForm.value;
    this.accountService.createTeam(team).subscribe(() => {
      this.snackBar.open('Invitation has been sent.', '', {
        duration: 3000,
      });
      this.discard();
    });
  }

  public discard(): void {
    this.matDialogRef.close();
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }
}
